import styled from "styled-components";

const Label = styled.label`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.03em;
  color: #3a4569;
  margin-bottom: 10px;
`;

export default Label;
